export default "__VITE_ASSET__DtK7PrnE__"